import React from 'react';

import CardContainer from './components/CardContainer';
import Thumbnail from './components/Thumbnail';
import Title from './components/Title';
import ContentCountry from './components/ContentCountry';

const CountryCard = ({ thumbnail, title, countDestinations, countHotels, slug }) => (
  <CardContainer slug={slug}>
    <Thumbnail src={thumbnail} />
    <Title title={title} />
    <ContentCountry numberOfDestinations={countDestinations} numberOfHotels={countHotels} />
  </CardContainer>
);

export default CountryCard;
